import { SelectOption } from '@rx-applications/shared/utils';

export type UserRoleType = 'admin' | 'booker';

export enum UserRoleCode {
  ADMIN = '903e6438-f737-42ca-b8e7-bcc46b042bf2',
  BOOKER = '2d073584-e0e8-4781-a9de-b24830266305',
}

export const RoleCodeToLabelMap: Map<UserRoleCode, string> = new Map([
  [UserRoleCode.ADMIN, 'admin'],
  [UserRoleCode.BOOKER, 'booker'],
]);

export const UserRolesOptions: SelectOption[] = [
  { label: 'admin', value: UserRoleCode.ADMIN },
  { label: 'booker', value: UserRoleCode.BOOKER },
];
